module.exports = __webpack_public_path__ + "static/media/hero-books.d2ff5ff2.webp";